/*! responsive.js | Adminuiux 2023-2024 */

"use strict";

$(window).on('resize', function () {
    //console.log($(window).width())
})